/**
 * 히어로 '예상 납부금액' 카드의 계산식. 화면과 분리해 두어 테스트로 금액을 검증한다.
 * 입력·결과 금액은 모두 만원 단위이고, 세금 계산만 원 단위 정수로 한다.
 */

const MAN = 10000;

/** 예상 이용금액 = 월평균 매출 × 200% (월 5천만원 → 1억원) */
export const LIMIT_RATE = 2;

/** 계약기간 (개월) */
export const CONTRACT_MONTHS = 12;

/**
 * 종합소득세 기본세율표 (2023년 귀속분부터).
 * 산출세액 = 과세표준 × 세율 − 누진공제. 세율은 부동소수 오차를 피하려고 % 정수로 둔다.
 */
export const INCOME_TAX_BRACKETS = [
  { upTo: 14000000, rate: 6, deduction: 0 },
  { upTo: 50000000, rate: 15, deduction: 1260000 },
  { upTo: 88000000, rate: 24, deduction: 5760000 },
  { upTo: 150000000, rate: 35, deduction: 15440000 },
  { upTo: 300000000, rate: 38, deduction: 19940000 },
  { upTo: 500000000, rate: 40, deduction: 25940000 },
  { upTo: 1000000000, rate: 42, deduction: 35940000 },
  { upTo: Infinity, rate: 45, deduction: 65940000 },
];

/** 과세표준(원)에 대한 종합소득세 산출세액(원) */
export function incomeTax(base) {
  if (base <= 0) return 0;
  const { rate, deduction } = INCOME_TAX_BRACKETS.find((b) => base <= b.upTo);
  return Math.round((base * rate) / 100 - deduction);
}

/**
 * @param sales  월평균 온라인·카드매출 (만원)
 * @param margin 이익률 (%)
 */
export function calcEstimate(sales, margin) {
  const yearSales = sales * 12;
  const costRate = 100 - margin; // 매입·필요경비 비율
  const costAmount = (yearSales * costRate) / 100; // 이익률 금액
  const limit = sales * LIMIT_RATE; // 예상 이용금액
  const monthPay = limit / CONTRACT_MONTHS;

  // 실제 이익금액에 대한 종합소득세 — BNPL 이용 전후를 비교해 절세액을 구한다.
  const profitWon = Math.round((yearSales - costAmount) * MAN);
  const limitWon = limit * MAN;
  const taxBefore = incomeTax(profitWon);
  const taxAfter = incomeTax(Math.max(0, profitWon - limitWon));
  const taxSaving = taxBefore - taxAfter;
  const monthBurden = (limitWon - taxSaving) / CONTRACT_MONTHS / MAN;

  return {
    yearSales,
    costRate,
    costAmount,
    limit,
    monthPay,
    taxBefore,
    taxAfter,
    taxSaving,
    monthBurden,
  };
}
